// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elt-wp-plugin {
  font-size: 16px;
}

.case-study-component {
  margin: 0 ;
}

.case-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.case-item {
  padding: 1rem;
  background: white;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.1);
  overflow: hidden; /* Expanded content stays within the border */
}

.case-item:hover {
  box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.2);
}


.case-format {
  font-size: 0.8rem;
  font-weight: bold;
  color: #555;
  background: #f5f5f5;
  padding: 0.2rem 0.4rem;
  margin: 0; /* 余白を削除 */
  border-radius: 12px;
  display: inline-block;
  white-space: nowrap; /* テキストが折り返されないように */
}



.case-header {
  display: flex;
  flex-direction: column; /* 縦方向に配置 */
  gap: 0.1rem; /* 子要素間のスペース */
  align-items: flex-start; /* 左揃え */
}


.case-header:hover {
  cursor: pointer;
}



.case-title-container {
  display: flex;
  gap: 1rem; /* title と recipient の間隔 */
  align-items: center; /* 縦方向のセンタリング */
}


/* タイトル用 */
.title {
  font-size: 1.6rem;
  font-family: serif;
  color: #2a3d86;
  font-weight: bold;
}

/* 受講者名用 */
.recipient {
  font-size: 1.2rem;
  font-weight: normal;
  color: #666;
}

/* 閉じるボタン */
.close-button {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: bold;
  color: #fff;
  background-color: #2a3d86; /* ボタンの背景色 */
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.close-button:hover {
  background-color: #1e2b5c; /* ホバー時の背景色 */
}


@media (max-width: 768px) {

  .case-title-container {
    flex-direction: column; /* モバイルでは縦並び */
    align-items: flex-start; /* 左揃え */
    gap: 0; /* 間隔を縮小 */
  }


  .title {
    margin-bottom: 0.1rem;
  }

  .recipient {
    display: block; /* モバイルでは改行して表示 */
    font-size: 1rem;
    color: #666;
  }

  .case-format {
    padding: 0.1rem 0.2rem;
  }

  .case-details li {
    font-size: 1rem;
  }
}

.case-details {
  font-size: 1.2rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #dcdcdc;
  animation: expand 0.3s ease-in-out;
}

.case-details ul {
  padding-left: 1.5rem;
  margin: 0.5rem 0;
  list-style: disc;
}

.case-details li {
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 1.2rem;
}

@keyframes expand {
  from {
    opacity: 0;
    transform: scaleY(0.8);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/CaseStudyComponent.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,8CAA8C;EAC9C,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE,8CAA8C;AAChD;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,SAAS,EAAE,UAAU;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB,EAAE,oBAAoB;AAC3C;;;;AAIA;EACE,aAAa;EACb,sBAAsB,EAAE,WAAW;EACnC,WAAW,EAAE,cAAc;EAC3B,uBAAuB,EAAE,QAAQ;AACnC;;;AAGA;EACE,eAAe;AACjB;;;;AAIA;EACE,aAAa;EACb,SAAS,EAAE,0BAA0B;EACrC,mBAAmB,EAAE,eAAe;AACtC;;;AAGA,UAAU;AACV;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB,EAAE,YAAY;EACvC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,aAAa;AAC1C;;;AAGA;;EAEE;IACE,sBAAsB,EAAE,cAAc;IACtC,uBAAuB,EAAE,QAAQ;IACjC,MAAM,EAAE,UAAU;EACpB;;;EAGA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc,EAAE,iBAAiB;IACjC,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF","sourcesContent":[".elt-wp-plugin {\n  font-size: 16px;\n}\n\n.case-study-component {\n  margin: 0 ;\n}\n\n.case-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.case-item {\n  padding: 1rem;\n  background: white;\n  border: 1px solid #dcdcdc;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.1);\n  overflow: hidden; /* Expanded content stays within the border */\n}\n\n.case-item:hover {\n  box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.2);\n}\n\n\n.case-format {\n  font-size: 0.8rem;\n  font-weight: bold;\n  color: #555;\n  background: #f5f5f5;\n  padding: 0.2rem 0.4rem;\n  margin: 0; /* 余白を削除 */\n  border-radius: 12px;\n  display: inline-block;\n  white-space: nowrap; /* テキストが折り返されないように */\n}\n\n\n\n.case-header {\n  display: flex;\n  flex-direction: column; /* 縦方向に配置 */\n  gap: 0.1rem; /* 子要素間のスペース */\n  align-items: flex-start; /* 左揃え */\n}\n\n\n.case-header:hover {\n  cursor: pointer;\n}\n\n\n\n.case-title-container {\n  display: flex;\n  gap: 1rem; /* title と recipient の間隔 */\n  align-items: center; /* 縦方向のセンタリング */\n}\n\n\n/* タイトル用 */\n.title {\n  font-size: 1.6rem;\n  font-family: serif;\n  color: #2a3d86;\n  font-weight: bold;\n}\n\n/* 受講者名用 */\n.recipient {\n  font-size: 1.2rem;\n  font-weight: normal;\n  color: #666;\n}\n\n/* 閉じるボタン */\n.close-button {\n  margin-top: 1rem;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  font-weight: bold;\n  color: #fff;\n  background-color: #2a3d86; /* ボタンの背景色 */\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.close-button:hover {\n  background-color: #1e2b5c; /* ホバー時の背景色 */\n}\n\n\n@media (max-width: 768px) {\n\n  .case-title-container {\n    flex-direction: column; /* モバイルでは縦並び */\n    align-items: flex-start; /* 左揃え */\n    gap: 0; /* 間隔を縮小 */\n  }\n\n\n  .title {\n    margin-bottom: 0.1rem;\n  }\n\n  .recipient {\n    display: block; /* モバイルでは改行して表示 */\n    font-size: 1rem;\n    color: #666;\n  }\n\n  .case-format {\n    padding: 0.1rem 0.2rem;\n  }\n\n  .case-details li {\n    font-size: 1rem;\n  }\n}\n\n.case-details {\n  font-size: 1.2rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #dcdcdc;\n  animation: expand 0.3s ease-in-out;\n}\n\n.case-details ul {\n  padding-left: 1.5rem;\n  margin: 0.5rem 0;\n  list-style: disc;\n}\n\n.case-details li {\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-size: 1.2rem;\n}\n\n@keyframes expand {\n  from {\n    opacity: 0;\n    transform: scaleY(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scaleY(1);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
